import { LinkRequestStatus } from "@wingspanhq/wingspan-api-sdk";
import React, { useMemo } from "react";
import { queriesLinkRequests } from "@query";
import { PendingInvitationAlert } from "./PendingInvitationAlert";

/**
 * Dashboard alerts for the logged-in user's unaccepted v3 invitations. Reads the
 * account's link requests and renders one accept-able alert per Pending request.
 * Renders nothing when there are none, so it is safe to mount unconditionally in
 * the alerts stack.
 */
export const PendingInvitationsAlerts: React.FC = () => {
  const queryLinkRequests =
    queriesLinkRequests.listPayerPayeeLinkRequests.useQuery({ filter: {} });

  const pendingLinkRequests = useMemo(
    () =>
      (queryLinkRequests.data?.data ?? []).filter(
        linkRequest => linkRequest.status === LinkRequestStatus.PENDING
      ),
    [queryLinkRequests.data]
  );

  return (
    <>
      {pendingLinkRequests.map(linkRequest => (
        <PendingInvitationAlert
          key={linkRequest.id}
          linkRequest={linkRequest}
        />
      ))}
    </>
  );
};
